(function () {
  'use strict';

  const DRAWER_ID = 'NewsletterDrawer';
  const TRIGGER_ATTR = 'data-newsletter-trigger';
  const CLOSE_ATTR = 'data-nd-close';
  const OPEN_CLASS = 'nd-open';

  function init() {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    const panel = drawer.querySelector('.nd-panel');
    let lastFocus = null;

    function getFocusable() {
      return Array.from(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // next frame so the transition fires
      requestAnimationFrame(() => {
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add(OPEN_CLASS);
      });
      // focus first focusable after the transition starts
      setTimeout(() => {
        const focusable = getFocusable();
        (focusable[0] || panel).focus({ preventScroll: true });
      }, 50);
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove(OPEN_CLASS);
      // wait for transition before hiding
      setTimeout(() => {
        drawer.hidden = true;
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        }
      }, 400);
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    // Triggers anywhere in the document
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[' + TRIGGER_ATTR + ']');
      if (trigger) {
        open(e);
        return;
      }
      const closer = e.target.closest('[' + CLOSE_ATTR + ']');
      if (closer && drawer.contains(closer)) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (drawer.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    });

    // Auto-open if the form posted successfully (Shopify form redirects with state)
    if (drawer.querySelector('.nd-success')) {
      open();
    }
    // Auto-open if there were form errors so the user can see them
    if (drawer.querySelector('.nd-error')) {
      open();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
